import React from 'react';

// Mapa explícito (não template string) — necessário pro Tailwind JIT. Ver docs/design-system/tokens.md
const TEXT_BY_MODULE = {
  finance: 'text-module-finance',
  travel: 'text-module-travel',
  planner: 'text-module-planner',
  health: 'text-module-health',
  core: 'text-module-core',
  identity: 'text-module-identity',
};

/**
 * NavbarBottom compartilhado. Antes duplicado 5x com tabs hardcoded por módulo.
 * As tabs em si continuam específicas de domínio (não dá pra generalizar sem perder
 * sentido) — o que este componente consolida é o shell (container, lógica de
 * ativo/inativo, markup do botão) e a cor via `moduleKey`.
 *
 * - `tabs`: [{ key, label, Icon }]
 * - `layout`: 'flex' (padrão, finance/travel/health) ou 'grid-4' (planner —
 *   necessário pro label "Tasks & Events" não quebrar em telas estreitas)
 * - `textSize`: 'xs' (padrão) ou 'tight' (planner, labels mais longos)
 */
const NavbarBottom = ({
  tabs = [],
  activeTab,
  onTabChange,
  moduleKey,
  layout = 'flex',
  textSize = 'xs',
  zIndexClass = '',
}) => {
  const activeColor = TEXT_BY_MODULE[moduleKey] || 'text-gray-700';
  const containerLayoutClass = layout === 'grid-4' ? 'grid grid-cols-4 gap-0' : 'flex justify-around';
  const textSizeClass = textSize === 'tight' ? 'text-[10px] sm:text-xs leading-tight px-0.5' : 'text-xs';

  return (
    <div className={`fixed bottom-0 left-0 right-0 bg-white border-t ${containerLayoutClass} py-2 shadow-md ${zIndexClass}`}>
      {tabs.map(({ key, label, Icon }) => (
        <button
          key={key}
          type="button"
          onClick={() => onTabChange(key)}
          className={`flex flex-col items-center ${textSizeClass} ${activeTab === key ? activeColor : 'text-gray-400'}`}
        >
          <Icon className={layout === 'grid-4' ? 'h-6 w-6 mb-1 mx-auto' : 'h-6 w-6 mb-1'} />
          {label}
        </button>
      ))}
    </div>
  );
};

export default NavbarBottom;
